import React from "react";
import { Card } from "../ui/Card";
import PropTypes from "prop-types";

const CardsInfo = (props) => {
  const { data, setFilter, filter } = props;
  const CARDS_ARRAY = [
    {
      title: "Total de servicios",
      value: data.smy,
      icon: "apps",
      text: "text-blue-600",
      filter: "",
    },
    {
      title: "Servicios activos",
      value: data.status?.ok,
      icon: "check_circle",
      text: "text-green-500",
      filter: "OK"
    },
    {
      title: "Servicios inactivos",
      value: data.status?.disconnected,
      icon: "warning",
      text: "text-yellow-600",
      filter: "DESCONECTADO"
    },
    {
      title: "Servicios con error",
      value: data.status?.error,
      icon: "error",
      text: "text-red-600",
      filter: "error"
    },
  ];

  return (
    <div>
      <div className="grid xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-2">
        {CARDS_ARRAY.map((item, index) => (
          <div key={index} onClick={() => setFilter(item.filter)}>
            <Card
              title={item.title}
              value={item.value}
              icon={item.icon}
              text={item.text}
              isSelected={item.filter === filter}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

CardsInfo.propTypes = {
  data: PropTypes.object,
  setFilter: PropTypes.func,
  filter: PropTypes.string,
};

export default CardsInfo;
